<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>
    {{ 'calendar.site.location' | translate }}
  </div>
  <h4>{{ 'site.blueprint' | translate }}</h4>
  <div class="flex">
    <ion-select interface="popover"
      label-placement="stacked"
      [value]="selectedBlueprint()"
      (ionChange)="onBlueprint($event)">
      @for (print of blueprints; track $index) {
        <ion-select-option [value]="print">
          {{ print.name }}
        </ion-select-option>
      } @empty {
        <app-no-results></app-no-results>
      }
    </ion-select>
  </div>
  @if (imageElement()) {
    <p>{{ 'site.locationInfo' | translate }}</p>
    <app-fabric [imgElement]="imageElement()"
      (save)="onSave($event)"></app-fabric>
  } @else if (selectedBlueprint()) {
    <img id="blueprint"
      [src]="selectedBlueprint().url"
      (load)="setBlueprintImage($event)" />
  }
</app-main-dialog>
@if (items().length > 0) {
  <ion-fab slot="fixed"
    horizontal="end"
    vertical="bottom">
    <ion-fab-button color="light"
      (click)="saveItems()">
      {{ 'general.save' | translate }}
    </ion-fab-button>
  </ion-fab>
}